/* sb-dc-proofstick.js - the approval checkbox should not be below the fold.
   2026-09-12.

   Reported (feedback item 18): the proof screen is long - you have to scroll
   inside the modal to reach the approval checkbox before you can continue.

   MEASURED (live, a 2ft x 2ft vinyl banner with one text layer): the modal is
   750px tall in a 798px window, and .modal-body scrolls 1,333px of content
   through a 594px window. The checkbox sat at y=1198 - 400px below the bottom
   of the screen, with nothing on screen saying so. The footer button reads
   "Confirm below to continue", pointing at something the customer cannot see.

   FIX: the acknowledgement rows are pinned to the bottom of the scrolling
   area (position: sticky). They stay part of the page and keep their own
   behaviour - this only stops them scrolling out of sight. Measured after:
   the checkbox sits at y=654, on screen, while the proof above it still
   scrolls normally.

   Two rows get this: label.ack (the approval) and .sbdc-ovr ("order anyway",
   which only appears when the checks found something). If a future proof
   screen adds another, add it to ROWS.

   NOT DONE, from the same feedback:
     - the wall/fence mockup with grommet dots. That is a new rendering, not a
       layout fix.
     - removing "Download print file". ruth's comment argues to keep it - that
       seeing the file makes customers surer about ordering - and the store has
       not settled it, so the button is untouched.

   CSS only. Nothing here changes what the checks do, what the proof says, or
   what gets ordered.

   Diagnostics: window.__dcProofStick() */
(function () {
  'use strict';

  var ROWS = ['label.ack', '.sbdc-ovr'];
  var ID = 'sbdc-proofstick-css';

  var info = { applied: false, why: '' };
  window.__dcProofStick = function () { return info; };

  function apply() {
    if (document.getElementById(ID)) return;
    var st = document.createElement('style');
    st.id = ID;
    var sel = ROWS.map(function (r) { return '.modal .modal-body > ' + r; }).join(',');
    st.textContent =
      sel + '{position:sticky;bottom:0;z-index:5;background:#fff;' +
      'border-top:1px solid #e2e8ef;padding:12px 4px;margin-top:8px;' +
      'box-shadow:0 -6px 14px rgba(7,39,71,.06);}' +
      /* on a short window the proof stage can crowd it out; keep it readable */
      '@media (max-height:620px){' + sel + '{padding:8px 4px;}}';
    (document.head || document.documentElement).appendChild(st);
    info.applied = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
